import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { FaUser, FaCalendarAlt } from "react-icons/fa";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import Footer from "../../../components/general/footer/Footer";
import { BlogSectionSkeleton } from "../../../components/general/skeleton/SkeletonBlock";
import "../../../assets/css/customer/blogs/SingleBlogPage.css";
import fertilizerNPK from "../../../assets/images/products/fertilizerNPK.webp";
import MyContext from "../../../context/MyContext";
import axios from "axios";
import Swal from "sweetalert2";

const SingleBlogPage = () => {
  const { baseUrl, baseUrlForFiles } = useContext(MyContext);
  const [blog, setBlog] = useState(null);
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const {selectedBlog} = useContext(MyContext);

  // useEffect(() => {
  //   const t = setTimeout(() => setLoading(false), 1100);
  //   return () => clearTimeout(t);
  // }, []);
  const viewSingleBlogDetail = () => {
    axios
      .get(`${baseUrl}/customer/blogs/viewSingleBlogDetail/${slug}`)
      .then((response) => {
        console.log(response.data);
        if (response.data.hasOwnProperty("error")) {
          setErrorMessage(response.data.error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.error,
          });
        } else {
          setBlog(response.data.blog);
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Blog cannot load",
        });
      });
  };
  useEffect(() => {
    console.log("Signle seelected blog,", selectedBlog);
    viewSingleBlogDetail();
    setLoading(false);
  }, []);

  if (loading)
    return (
      <>
        <section className="single-blog-page">
          <MyNavbar />
          <BlogSectionSkeleton />
        </section>
        <Footer />
      </>
    );

  return (
    <>
      <section className="single-blog-page">
        <MyNavbar />
        <Container>
          {/* Blog Header */}
          <div className="blog-header-section">
            <h1 className="blog-main-title">{blog?.title}</h1>

            {/* Blog Meta */}
            <div className="blog-meta-info">
              <div className="meta-item">
                <FaUser />
                <span>{blog?.author}</span>
              </div>
              <div className="meta-item">
                <FaCalendarAlt />
                <span>
                  {blog?.created_at
                    ? new Date(blog.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : ""}
                </span>
              </div>
            </div>
          </div>

          {/* Featured Image */}
          <div className="featured-image-wrapper">
            <img
              src={`${baseUrlForFiles}/${blog?.image}`}
              alt={blog?.title}
              className="featured-image"
            />
          </div>

          {/* Blog Content */}
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <div
                className="blog-main-content"
                dangerouslySetInnerHTML={{
                  __html: blog?.description || "",
                }}
              />

              {/* Tags */}
              <div className="tags-section">
                {blog?.keywords &&
                  blog.keywords.split(",").map((keyword, index) => (
                    <span className="tag" key={index}>
                      #{keyword.trim()}
                    </span>
                  ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default SingleBlogPage;
